module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/starbucks-2a1f7cde06168dc0324bdf7e54642f56.webp";